import { TemplateCart } from '@modules/BillOfMaterials/Components/TemplateCart/TemplateCart';
import { useEffect, useRef } from 'react';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import { ROUTES } from '@configs/AppRoutes';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { notifyErrorCustom } from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { useNavigate } from 'react-router-dom';
import { CustomProjectInfoViewModel } from '@viewModels/CustomProjectInfoViewModel';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';

const TemplateCartPage: React.FC = () => {
    const {
        shouldRedirectToNewProjectAfterAuthorization,
        currentTemplate,
        setShouldRedirectToNewProjectAfterAuthorization,
    } = useTemplatesViewModel();

    const isProcessingRef = useRef<boolean>(false);
    const navigate = useNavigate();
    const projectViewModel = new CustomProjectInfoViewModel();

    useEffect(() => {
        const handleRedirectToNewFreeProject = async () => {
            if (
                shouldRedirectToNewProjectAfterAuthorization &&
                currentTemplate &&
                !currentTemplate.paid
            ) {
                isProcessingRef.current = true;
                try {
                    const newProjectResponse =
                        await projectViewModel.createNewProjectWithFreeTemplate(
                            [currentTemplate?.id]
                        );
                    if (!newProjectResponse.error && newProjectResponse.data) {
                        const path = ROUTES.STEP1.getPath(
                            StepsViewModeEnum.PROJECT,
                            String(newProjectResponse.data.id)
                        );
                        navigate(path);
                    }
                } catch (error) {
                    navigate(ROUTES.BOM);
                    notifyErrorCustom('Failed to create new project');
                }
                setShouldRedirectToNewProjectAfterAuthorization(false);
                isProcessingRef.current = false;
            }
        };

        handleRedirectToNewFreeProject();
    }, [shouldRedirectToNewProjectAfterAuthorization]);

    if (shouldRedirectToNewProjectAfterAuthorization) return <BasicLoader />;

    return <TemplateCart />;
};

export default TemplateCartPage;
